import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '@clerk/react';
import { LogoFull } from '../components/Logo';
import { usePlatformSettings } from '../hooks/usePlatformSettings';

const G = '#004D35';
const BORDER = '#e8e5e0';
const BG = '#f5f3ef';

const GetStarted = () => {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded, user } = useUser();
  const { settings: platformSettings } = usePlatformSettings();

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !user) return;
    const role = user.publicMetadata?.role;
    if (role === 'admin') navigate('/admin', { replace: true });
    else if (role === 'advisor') navigate('/advisor-portal', { replace: true });
    else navigate('/onboarding', { replace: true });
  }, [isLoaded, isSignedIn, user, navigate]);

  const handleAdvisor = () => {
    window.open(platformSettings.advisor_application_url || 'https://form.typeform.com/to/rY6K3qQg', '_blank', 'noopener noreferrer');
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: BG }}>
      <nav style={{
        background: '#fff',
        borderBottom: `1px solid ${BORDER}`,
        padding: '0 40px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <LogoFull size={26} />
        </Link>
        <Link
          to="/"
          style={{ fontSize: 13, fontFamily: 'sans-serif', color: '#aaa', textDecoration: 'none' }}
          onMouseEnter={e => e.target.style.color = '#555'}
          onMouseLeave={e => e.target.style.color = '#aaa'}
        >
          ← Back to home
        </Link>
      </nav>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 56px)',
        padding: '40px 24px',
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 20,
          padding: '48px 44px',
          width: '100%',
          maxWidth: 480,
          boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
        }}>
          <div style={{ marginBottom: 28 }}>
            <LogoFull size={28} />
          </div>

          <h1 style={{
            fontSize: 26,
            fontWeight: 500,
            color: '#0a1a0f',
            margin: '0 0 6px',
            fontFamily: 'Georgia, serif',
          }}>
            Join Viysr as an Advisor
          </h1>
          <p style={{
            fontSize: 14,
            color: '#aaa',
            fontFamily: 'sans-serif',
            margin: '0 0 28px',
          }}>
            Apply to join our verified network of San Diego business advisors.
          </p>

          <button
            onClick={handleAdvisor}
            style={{
              width: '100%',
              background: G,
              color: '#fff',
              border: 'none',
              borderRadius: 14,
              padding: '18px 20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 16,
              fontSize: 15,
              fontWeight: 700,
              fontFamily: 'Georgia, serif',
              marginBottom: 12,
            }}
          >
            <div style={{ textAlign: 'left' }}>
              <div style={{ marginBottom: 3 }}>Apply to join as an advisor</div>
              <div style={{ fontSize: 13, fontWeight: 400, opacity: 0.7 }}>
                Application takes 5 minutes
              </div>
            </div>
            <span style={{ fontSize: 18 }}>→</span>
          </button>

          <div style={{
            textAlign: 'center',
            marginTop: 28,
            paddingTop: 24,
            borderTop: `1px solid ${BORDER}`,
          }}>
            <p style={{ fontSize: 13, color: '#aaa', fontFamily: 'sans-serif', margin: 0 }}>
              Already have an account?{' '}
              <button
                onClick={handleSignIn}
                style={{
                  background: 'none',
                  border: 'none',
                  color: G,
                  fontWeight: 700,
                  fontSize: 13,
                  fontFamily: 'sans-serif',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                Sign in →
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
